import React from "react";
import DropRight from "./icons/DropRight";

const Pagination = ({
  totalItems,
  currentPage,
  totalPages,
  onPreviousPage,
  onNextPage,
  isPreviousDisabled,
  isNextDisabled,
  itemLength,
  isViewNext,
  limit = 10,
}) => {
  const currentTotal = totalItems || 0;
  const currPage = currentPage || 1;
  const startItem = currentTotal > 0 ? (currPage - 1) * limit + 1 : 0;
  const endItem = Math.min((currPage - 1) * limit + (itemLength || 0), currentTotal);

  return (
    <div className="py-3 px-5 flex flex-col sm:flex-row items-center justify-between gap-3 bg-gray-50/70 border-t border-primary-100 rounded-b-[12px]">
      {/* Left Side: Item Counts */}
      <div className="flex items-center gap-1.5 text-[12px] font-medium text-gray-500">
        <span>Showing</span>
        <span className="font-bold text-gray-800 font-mono">
          {startItem} - {endItem}
        </span>
        <span>of</span>
        <span className="font-bold text-gray-800 font-mono">{currentTotal}</span>
        <span>results</span>
      </div>

      {/* Right Side: Navigation Controls */}
      <div className="flex items-center gap-3">
        {/* Page Indicator */}
        <div className="px-3 py-1 bg-white border border-gray-200 rounded-full text-[12px] font-semibold text-gray-600 shadow-2xs">
          Page <span className="font-bold text-primary-700">{currPage}</span> of{" "}
          <span className="font-bold text-gray-800">{totalPages || 1}</span>
        </div>

        {/* Action Buttons */}
        <div className="flex items-center gap-1.5">
          <button
            type="button"
            disabled={isPreviousDisabled}
            onClick={onPreviousPage}
            className="inline-flex items-center gap-1 px-3 py-1.5 bg-white border border-gray-200 rounded-full text-[12px] font-bold text-gray-700 hover:text-primary-600 hover:border-primary-200 hover:bg-primary-50 transition-all active:scale-95 disabled:opacity-40 disabled:pointer-events-none shadow-2xs cursor-pointer"
            title="Previous Page"
          >
            <div className="rotate-180">
              <DropRight width={12} height={12} fill="currentColor" />
            </div>
            <span>Previous</span>
          </button>

          <button
            type="button"
            disabled={isNextDisabled || isViewNext}
            onClick={onNextPage}
            className="inline-flex items-center gap-1 px-3 py-1.5 bg-white border border-gray-200 rounded-full text-[12px] font-bold text-gray-700 hover:text-primary-600 hover:border-primary-200 hover:bg-primary-50 transition-all active:scale-95 disabled:opacity-40 disabled:pointer-events-none shadow-2xs cursor-pointer"
            title="Next Page"
          >
            <span>Next</span>
            <DropRight width={12} height={12} fill="currentColor" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Pagination;
